import {Component, Input, OnChanges} from "@angular/core";

export const STANARD_ERRORS = {
  'required': 'Eine Eingabe ist erforderlich!'
};

@Component({
  selector: 'vb-form-control-message',
  templateUrl: './form-control-message.component.html',
  styleUrls: ['./form-control-message.component.css']
})
export class FormControlMessageComponent implements OnChanges {

  @Input()
  inputErrors: {[errorId: string]: any};

  private _errorDefs: {[errorId: string]: string} = STANARD_ERRORS;

  @Input()
  set errorDefs(value: {[errorId: string]: string}) {
    this._errorDefs = Object.assign(STANARD_ERRORS, value);
  }

  get errorDefs(): {[errorId: string]: string} {
    return this._errorDefs;
  }

  errorMessage: string = '';

  ngOnChanges(changes: any): void {
    let errors: any = changes.inputErrors.currentValue;
    this.errorMessage = '';
    if (errors) {
      Object.keys(this._errorDefs).some(key => {
        if (errors[key]) {
          this.errorMessage = this._errorDefs[key];
          return true;
        }
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/forms/directives/form-control-message/form-control-message.component.ts